var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeguraca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_15073",
    "data-name": "Grupo 15073",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.527,
    height: 44.527,
    viewBox: "0 0 44.527 44.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 22.263,
    cy: 22.263,
    r: 22.263,
    fill: "#009bde"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dns_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "dns_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M125.16-835.228a1.482,1.482,0,0,0-1.094.452,1.5,1.5,0,0,0-.448,1.1,1.483,1.483,0,0,0,.452,1.094,1.5,1.5,0,0,0,1.1.448,1.482,1.482,0,0,0,1.094-.452,1.5,1.5,0,0,0,.448-1.1,1.482,1.482,0,0,0-.452-1.094A1.5,1.5,0,0,0,125.16-835.228Zm0,12.8a1.483,1.483,0,0,0-1.094.452,1.5,1.5,0,0,0-.448,1.1,1.482,1.482,0,0,0,.452,1.094,1.5,1.5,0,0,0,1.1.448,1.482,1.482,0,0,0,1.094-.452,1.5,1.5,0,0,0,.448-1.1,1.482,1.482,0,0,0-.452-1.094A1.5,1.5,0,0,0,125.16-822.426ZM121.051-839h20.13a1.065,1.065,0,0,1,.788.294,1.078,1.078,0,0,1,.294.8v8.308a1.393,1.393,0,0,1-.294.9.96.96,0,0,1-.788.365h-20.13a.929.929,0,0,1-.758-.365,1.393,1.393,0,0,1-.294-.9v-8.308a1.078,1.078,0,0,1,.294-.8A1.025,1.025,0,0,1,121.051-839Zm.8,1.855v6.957h18.553v-6.957Zm-.8,10.915h20.006a1.133,1.133,0,0,1,.835.386,1.239,1.239,0,0,1,.371.882v8.162a1.186,1.186,0,0,1-.371.943,1.235,1.235,0,0,1-.835.325H121.206a1.218,1.218,0,0,1-.85-.325A1.213,1.213,0,0,1,120-816.8v-8.162a1.419,1.419,0,0,1,.294-.882A.91.91,0,0,1,121.051-826.229Zm.8,1.855v6.988h18.553v-6.988Zm0-12.771v0Zm0,12.771v0Z",
    transform: "translate(-108.869 849.528)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguraca);
export default __webpack_public_path__ + "static/media/seguraca.f7d12586e6169b7ac7e500e87608e911.svg";
export { ForwardRef as ReactComponent };